import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

export default function RightOfWithdrawalScreen() {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.resolvedLanguage;

  const SECTIONS = [
    { id: 1, rows: 1 }, // Einleitung
    { id: 2, rows: 4 }, // Widerrufsrecht
    { id: 3, rows: 4 }, // Folgen des Widerrufs
    { id: 4, rows: 1 }, // Ausschluss …
    { id: 5, rows: 13 }, // Widerrufsformular
  ];

  return (
    <Container>
      <div className="container small-container">
        <title>{t('withdrawal-screen-helmet')}</title>

        <h1 className="screen-heading">{t('withdrawal-screen-heading')}</h1>

        <Row className="text-container">
          <Col>
            {SECTIONS.map(({ id, rows }) => (
              <div
                key={id}
                className="text-container-section"
                style={{ overflow: 'hidden' }}
              >
                <h4>{t(`withdrawal-screen-section-${id}-heading`)}</h4>

                {Array.from({ length: rows }, (_, i) => (
                  <p
                    key={i}
                    dangerouslySetInnerHTML={{
                      __html: t(`withdrawal-screen-section-${id}-row-${i + 1}`),
                    }}
                  />
                ))}
              </div>
            ))}

            {selectedLanguage !== 'de' && (
              <p className="translation-info">
                <i>{t('withdrawal-screen-translation-info')}</i>
              </p>
            )}
          </Col>
        </Row>
      </div>
    </Container>
  );
}
